<template>
    <div>
        <Modal v-model="mainTable.sarchCardShow"
            title="搜索条件"
            :width="1000"
            footer-hide>
            <search-card :form="mainTable.searchForm"
                :table-load-event="getSaleStatList"
                :table-search="mainTable.tableSearch" />
        </Modal>

        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">销售统计(定金单)</span>
						<span style="margin-left:10px;font-size:12px;">下单时间:</span>
						<DatePicker type="daterange"
						    v-model="selectDepositDates"
						    size="small"
						    transfer
						    :clearable="false"
						    placement="bottom-end"
						    placeholder="选择期初和期末时间"
						    style=" margin-left:4px;width:175px"
						    @on-change="onDateChange"></DatePicker>
                        <span style="margin-left:10px;font-size:12px;">订单状态:</span>
						<Select v-model="paidStatus" style=" margin-left:4px;width:100px" size="small" @on-change="onPaidStatusChange">
							<Option value="全部">全部</Option>
							<Option value="定金已支付">定金已支付</Option>
							<Option value="全额支付">全额支付</Option>
						</Select>
                       <!-- <DatePicker type="daterange"
                            v-model="selectDates"
                            size="small"
                            transfer
                            :clearable="false"
                            placement="bottom-end"
                            placeholder="选择期初和期末时间"
                            style=" margin-left:4px;width:175px"
                            @on-change="onDateChange"
							></DatePicker> -->
						
						<span style="margin-left:10px;font-size:12px;">会员类别:</span>
                        <RadioGroup v-model="userType"
                            style="margin-left:10px;"
                            @on-change="onUserTypeChange">
                            <Radio label="F"> <span>外部</span></Radio>
                            <Radio label="E"> <span>内部</span></Radio>
                        </RadioGroup>
						<span style="margin-left:10px;font-size:12px;">是否0价单:</span>
						<RadioGroup v-model="totalOrderCost"
						    style="margin-left:10px;"
						    @on-change="onTotalOrderCostChange">
						    <Radio label="0"> <span>否</span></Radio>
						    <Radio label="1"> <span>是</span></Radio>
						</RadioGroup>
                        <RadioGroup v-model="groupBy"
                            style="margin-left:10px;"
                            type="button"
                            size="small"
                            @on-change="onGroupByChange">
                            <Radio label="seedFarm"> <span>苗场</span> </Radio>
                            <Radio label="manager"> <span>经理</span> </Radio>
							<Radio label="station"> <span>转运站</span> </Radio>
                            <Radio label="product"> <span>商品</span> </Radio>
                            <Radio label="member"> <span>会员</span> </Radio>
                            <Radio label="mainCate"> <span>大类</span> </Radio>
                            <Radio label="subCate"> <span>小类</span> </Radio>
							<Radio label="province"> <span>省</span> </Radio>
							<Radio label="city"> <span>市</span> </Radio>
							<Radio label="dist"> <span>区</span> </Radio>
                        </RadioGroup>
                    </div>
                    <div class="right-bar">
                        <Button type="info"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-send"
                            @click="onExport()">导出</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.statColumns"
                    :data="mainTable.data"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :extHeight="-50"
                    :table-load-event="getSaleStatList"
                    :showPage="false"/>
                </Col>
            </Row>
			
        </Card>

        <Modal v-model="combineStatDetail.show"
            title="销售明细"
            :width="1200"
			:closable = "false"
			footer-hide>
			<Card :padding="0"
			    :bordered="false"
			    :dis-hover="true">
				<Row :gutter="16">
				    <Col span="24">
				    <div class="global-tool-bar">
				        <div class="left-bar">
				            <span class="title">销售明细列表</span>
				        </div>
				        <div class="right-bar">
				            <!-- <Checkbox v-model="combineStatDetail.showZeroPriceOnly"
				            	@on-change="onshowZeroPrice">只看零价商品</Checkbox> -->
				            <Button type="info"
				            	size='small'
				            	class="btns"
				            	shape="circle"
				            	icon="ios-send"
				            	@click="onDetailExport()">导出</Button>
				        </div>
				    </div>
				    </Col>
				</Row>
				<Row :gutter="16">
					<Col span="24">
					<stand-pagination-table :columns="combineStatDetail.preSaleColumns"
						:data="combineStatDetail.preSaleData"
						:loading="combineStatDetail.loading"
						:table-search="combineStatDetail.tableSearch"
						:table-load-event="showCombineStatDetail"
						:autoHeight="true"
						:showPage="true" />
					</Col>
				</Row>
			</Card>
				<div slot="header" class="div-header">
					<Button class="btn-font" type="text" @click="cancal">✕</Button>
				</div>
        </Modal>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateTimeRender, dateRender } from '@/libs/tableRowTimeRender';
import { numberToFixed, number2ThousandsFormat } from '@/components/number-input/display-format';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';
import { getDepositCombineSaleStat, getDepositCombineSaleStatDetail } from '@/api/modules/sale-management/sale-stat';
import { getRegionCascade } from '@/api/modules/system-management/region-management';
import { DOWNLOAD_SERVER } from '@/api/modules/files';

export default {
    name: 'sale-stat-list',
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            userType:'F',
            totalOrderCost:'',
            groupBy: 'seedFarm',
            selectDepositDates:[],
            paidStatus:'全部',
            //selectDates: [],
            allRegions: [],
            mainTable: {
                statColumns: [],
                data: [],
                sarchCardShow: false,
                searchForm: [],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            combineStatDetail: {
                uuid: '',
                show: false,
                loading: false,
                showZeroPriceOnly: false,
                preSaleData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                preSaleColumns: [
                    { title: '定金单编号', key: 'depositBillRecordCode', width: 160, align: 'center', excel: true },
                    //	{ title: '发货单编号', key: 'preSaleDeliveryRecordCode', width: 160, align: 'center', excel: true },
                    { title: '苗场编号', key: 'seedFarmCode', width: 80, align: 'center', excel: true },
                    { title: '苗场名称', key: 'seedFarmName', width: 100, align: 'center', excel: true },
                    { title: '客户名称', key: 'orderOwerPersonName', width: 80, align: 'center', excel: true },
                    { title: '客户账号', key: 'orderOwner', width: 60, align: 'center', excel: true },
                    { title: '客户电话', key: 'orderOwnerPhone', width: 100, align: 'center', excel: true },
                    { title: '区域', key: 'regionName', width: 100, align: 'center', excel: true },
                    //     { title: '定金金额', key: 'depositDue', width: 80, align: 'right', excel: true },
                    { title: '已付定金', key: 'depositDuePaid', width: 80, align: 'right', excel: true },
                    {
                        title: '下单时间', key: 'preSaleDeliveryRecordCreateAt', width: 130, align: 'center',
                        render: (h, params) => dateTimeRender(h, params.row.preSaleDeliveryRecordCreateAt), excel: true
                    },
                    { title: '商品编号', key: 'productCode', width: 60, align: 'center', excel: true },
                    { title: '商品名称', key: 'productName', width: 100, align: 'center', excel: true },
                    { title: '单位', key: 'unitName', width: 60, align: 'center', excel: true },
                    { title: '大类', key: 'mainCategoryName', width: 100, align: 'center', excel: true },
                    { title: '小类', key: 'subCategoryName', width: 100, align: 'center', excel: true },
                    { title: '周次', key: 'weekSeq', width: 60, align: 'center', excel: true },
                    { title: '单价', key: 'preSaleDeliveryDetailActProductPrice', width: 60, align: 'right', excel: true },
                    { title: '数量', key: 'preSaleDeliveryDetailQuantity', width: 80, align: 'center', excel: true },
                    { title: '销售金额', key: 'preSaleDeliveryDetailActProductCost', width: 80, align: 'right', excel: true },
                    { title: '优惠金额', key: 'saleDiscountValue', width: 80, align: 'right', excel: true,
					    render: (h, params) => {
					        const saleDiscountValue = params.row.saleDiscountValue ? params.row.saleDiscountValue : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(saleDiscountValue, 3, ''))
					        ]);
					    } },
                    { title: '退货金额', key: 'refundTotalVal', width: 80, align: 'right', excel: true },
                    { title: '有效金额', key: 'saleRealValue', width: 80, align: 'right', excel: true,
					    render: (h, params) => {
					        const saleRealValue = params.row.saleRealValue ? params.row.saleRealValue : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(saleRealValue, 3, ''))
					        ]);
					    } },
                    { title: '经理', key: 'managerName', width: 80, align: 'center', excel: true },
                    { title: '经理提成', key: 'depositBillDetailsalesAssociateCommissionValue', width: 80, align: 'right', excel: true },
                    { title: '转运站', key: 'distributionStationName', width: 80, align: 'center', excel: true },
                    {
                        title: '苗场发货', key: 'preSaleDeliveryRecordDeliveryDate', width: 80, align: 'center',
                        render: (h, params) => dateRender(h, params.row.preSaleDeliveryRecordDeliveryDate), excel: true
                    },
                    {
                        title: '转运站发货', key: 'stationDeliveryDate', width: 80, align: 'center',
                        render: (h, params) => dateRender(h, params.row.stationDeliveryDate), excel: true
                    }
                ]
            }
        };
    },
    // props: {
    //     userType: { type: String, default: 'F' }
    // },
    mounted() {
        // let beginDate = this.getThisMonthStart();
        //let endDate = this.getTodayDateString();
        //this.selectDates = [beginDate, endDate];
        let orderBeginDate = this.getThisMonthStart();
        let orderEndDate = this.getTodayDateString();
        this.selectDepositDates = [orderBeginDate, orderEndDate];
        this.getAllRegionList();
        this.init();
    },
    methods: {
        reSetColumns(){
            if(this.groupBy=="product"||this.groupBy=="mainCate"||this.groupBy=="subCate"){
                this.mainTable.statColumns=[
                    { title: '统计项', key: 'groupName', align: 'center' },
                    {
					    title: '销售数量',
					    key: 'preSaleCount',
					    align: 'center'
                    },
                    {
					    title: '销售金额',
					    key: 'preSaleValue',
					    align: 'right',
					    width: 120,
					    render: (h, params) => {
					        const preSaleValue = params.row.preSaleValue ? params.row.preSaleValue : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(preSaleValue, 2, ''))
					        ]);
					    }
                    },
                    {
					    title: '优惠金额',
					    key: 'saleDiscountValue',
					    align: 'right',
					    render: (h, params) => {
					        const saleDiscountValue = params.row.saleDiscountValue ? params.row.saleDiscountValue : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(saleDiscountValue, 2, ''))
					        ]);
					    }
                    },
                    {
					    title: '退货金额',
					    key: 'refundTotalVal',
					    align: 'right',
					    render: (h, params) => {
					        const refundTotalVal = params.row.refundTotalVal ? params.row.refundTotalVal : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(refundTotalVal, 2, ''))
					        ]);
					    }
                    },
                    {
					    title: '有效金额',
					    key: 'saleRealValue',
					    align: 'right',
					    render: (h, params) => {
					        const saleRealValue = params.row.saleRealValue ? params.row.saleRealValue : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(saleRealValue, 2, ''))
					        ]);
					    }
                    },
                    {
					    title: '销售定金',
					    key: 'combinDeposit',
					    align: 'right',
					    render: (h, params) => {
					        const combinDeposit = params.row.combinDeposit ? params.row.combinDeposit : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(combinDeposit, 2, ''))
					        ]);
					    }
                    },
                    {
					    title: '客户经理提成',
					    key: 'commissionValue',
					    align: 'right',
					    render: (h, params) => {
					        const commissionValue = params.row.commissionValue ? params.row.commissionValue : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(commissionValue, 2, ''))
					        ]);
					    }
                    },
                    {
					    title: '操作',
					    key: 'action',
					    align: 'center',
					    width: 250,
					    render: (h, params) => {
					        if (params.row.action === -1) {
					            return '';
					        }
					        else {
					            return h('div', [
					                h('Button', {
					                    props: {
					                        type: 'text',
					                        size: 'small',
					                        shape: 'circle'
					                    },
					                    on: {
					                        click: () => {
					                            this.showCombineStatDetail(params.row.uuid);
					                        }
					                    }
					                }, '查看明细')
					            ]);
					        }
					    }
                    }
                ];
            }
            else{
                this.mainTable.statColumns=[{ title: '统计项', key: 'groupName', align: 'center' },
                    {
                        title: '销售数量',
                        key: 'preSaleCount',
                        align: 'center'
                    },
                    {
                        title: '销售金额',
                        key: 'preSaleValue',
                        align: 'right',
                        width: 120,
                        render: (h, params) => {
                            const preSaleValue = params.row.preSaleValue ? params.row.preSaleValue : 0;
                            return h('div', {}, [
                                h('span', {}, number2ThousandsFormat(preSaleValue, 2, ''))
                            ]);
                        }
                    },
                    {
					    title: '优惠金额',
					    key: 'saleDiscountValue',
					    align: 'right',
					    render: (h, params) => {
					        const saleDiscountValue = params.row.saleDiscountValue ? params.row.saleDiscountValue : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(saleDiscountValue, 2, ''))
					        ]);
					    }
                    },
                    {
					    title: '退货金额',
					    key: 'refundTotalVal',
					    align: 'right',
					    render: (h, params) => {
					        const refundTotalVal = params.row.refundTotalVal ? params.row.refundTotalVal : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(refundTotalVal, 2, ''))
					        ]);
					    }
                    },
                    {
					    title: '有效金额',
					    key: 'saleRealValue',
					    align: 'right',
					    render: (h, params) => {
					        const saleRealValue = params.row.saleRealValue ? params.row.saleRealValue : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(saleRealValue, 2, ''))
					        ]);
					    }
                    },
                    {
                        title: '销售定金',
                        key: 'combinDeposit',
                        align: 'right',
                        render: (h, params) => {
                            const combinDeposit = params.row.combinDeposit ? params.row.combinDeposit : 0;
                            return h('div', {}, [
                                h('span', {}, number2ThousandsFormat(combinDeposit, 2, ''))
                            ]);
                        }
                    },
                    {
					    title: '客户经理提成',
					    key: 'commissionValue',
					    align: 'right',
					    render: (h, params) => {
					        const commissionValue = params.row.commissionValue ? params.row.commissionValue : 0;
					        return h('div', {}, [
					            h('span', {}, number2ThousandsFormat(commissionValue, 2, ''))
					        ]);
					    }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 250,
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return '';
                            }
                            else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        on: {
                                            click: () => {
                                                this.showCombineStatDetail(params.row.uuid);
                                            }
                                        }
                                    }, '查看明细')
                                ]);
                            }
                        }
                    }];
            }
        },
        reSetsearchForm(){
            if(this.groupBy=="product"||this.groupBy=="mainCate"||this.groupBy=="subCate"){
                this.mainTable.searchForm=[{ label: '会员', type: 'Input', value: '', name: 'userPersonName', sql: 'like' },
                    { label: '苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' },
                    { label: '大类', type: 'Input', value: '', name: 'mainCategoryName', sql: 'like' },
                    { label: '小类', type: 'Input', value: '', name: 'subCategoryName', sql: 'like' },
                    { label: '转运站', type: 'Input', value: '', name: 'distributionStationName', sql: 'like' },
                    { label: '客户经理', type: 'Input', value: '', name: 'userCustomerManagerName', sql: 'like' },
                    { label: '商品信息', type: 'Input', value: '', name: 'productName', sql: 'like' }];
            }
            else{
                this.mainTable.searchForm=[{ label: '会员', type: 'Input', value: '', name: 'userPersonName', sql: 'like' },
				    { label: '苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' },
                    { label: '转运站', type: 'Input', value: '', name: 'distributionStationName', sql: 'like' },
				    { label: '客户经理', type: 'Input', value: '', name: 'userCustomerManagerName', sql: 'like' }];
            }
        },
        getTodayDateString,
        getThisMonthStart,
        cancal(){
            this.combineStatDetail.tableSearch.limit.conditions.pageStart=1;
            this.combineStatDetail.tableSearch.limit.conditions.pageLength = 10;
            this.combineStatDetail.show = false; 
        },
        init() {
            this.getSaleStatList();
        },
        onSaleChage(e) {
            this.getSaleStatList(true);
        },
        onUserTypeChange(e) {
            this.getSaleStatList();
        },
        onTotalOrderCostChange(e) {
		    this.getSaleStatList();
        },
        onPaidStatusChange(e) {
		    this.getSaleStatList();
        },
        onGroupByChange(e) {
            this.mainTable.tableSearch.filters.conditions=[];
            this.combineStatDetail.tableSearch.filters.conditions=[];
            this.getSaleStatList();
        },
        onDateChange() {
            this.getSaleStatList();
        },
        getAllRegionList() {
            getRegionCascade().then(res => {
                if (res.code === 0) {
                    let find = this.mainTable.searchForm.find(item => item.name === 'memberDeliveryAddressDistUuid');
                    if (find) {
                        find.cascaderData = res.data.regionCascader;
                    }
                }
            });
        },
        onExport() {
            this.mainTable.loading = true;
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.tableSearch.needExport = 1;
            this.mainTable.tableSearch.groupBy = this.groupBy;
            // if(this.selectDates[0]&&this.selectDates[1]){
            // 	this.mainTable.tableSearch.beginDate = this.selectDates[0];
            // 	this.mainTable.tableSearch.endDate = this.selectDates[1];
            // }
            if(this.selectDepositDates[0]&&this.selectDepositDates[1]){
                this.mainTable.tableSearch.orderBeginDate = this.selectDepositDates[0];
                this.mainTable.tableSearch.orderEndDate = this.selectDepositDates[1];
            }
			
            if(this.paidStatus){
                this.mainTable.tableSearch.paidStatus = this.paidStatus;
            }
            this.mainTable.tableSearch.totalOrderCost = this.totalOrderCost;
            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }
            getDepositCombineSaleStat(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                    }
                }
                this.mainTable.loading = false;
            });
        },
        onDetailExport() {
            this.combineStatDetail.tableSearch = search.deepClone(this.mainTable.tableSearch);
            search.globalRemoveFilterConditionKey(this.combineStatDetail.tableSearch, "memberType");
            this.combineStatDetail.tableSearch.filters.enable = true;
            this.combineStatDetail.tableSearch.filters.conditions.push({
                name: 'memberType',
                type: 'eq',
                value: this.userType
            });
            this.combineStatDetail.tableSearch.totalOrderCost = this.totalOrderCost;
            this.combineStatDetail.tableSearch.limit.enable = false;
            this.combineStatDetail.tableSearch.uuid = this.combineStatDetail.uuid;
            this.combineStatDetail.tableSearch.showZeroPriceOnly = this.combineStatDetail.showZeroPriceOnly;

            this.combineStatDetail.tableSearch.excelExport.enable = true;

            this.combineStatDetail.tableSearch.excelExport.columns2 = this.combineStatDetail.preSaleColumns
                .filter(col => col.excel)
                .map(col => {
                    return {
                        key: col.key,
                        title: col.title
                    };
                });

            this.combineStatDetail.loading = true;
            getDepositCombineSaleStatDetail(this.combineStatDetail.tableSearch).then(res => {
                this.combineStatDetail.loading = false;
                if (res.code === 0) {
                    let url = DOWNLOAD_SERVER + res.data.exportFileName2;
                    this.$downLoadFile(url);
                }
            });
        },
        onshowZeroPrice() {
            this.showCombineStatDetail(this.combineStatDetail.uuid);
        },
        showCombineStatDetail(uuid) {
            this.combineStatDetail.tableSearch.filters.conditions=[];
            //将主列表的搜索条件遍历赋值给明细列表，成为明细列表的搜索条件
            this.mainTable.tableSearch.filters.conditions.forEach(item =>{
                search.globalRemoveFilterConditionKey(this.combineStatDetail.tableSearch, item.name);
                this.combineStatDetail.tableSearch.filters.enable = true;
                this.combineStatDetail.tableSearch.filters.conditions.push({
                    name: item.name,
                    type: 'eq',
                    value: item.value
                });
            });
            this.combineStatDetail.tableSearch.groupBy = this.groupBy;
            this.combineStatDetail.tableSearch.paidStatus = this.paidStatus;
			
            // if(this.selectDates[0]&&this.selectDates[1]){
            // 	this.combineStatDetail.tableSearch.beginDate = this.selectDates[0];
            // 	this.combineStatDetail.tableSearch.endDate = this.selectDates[1];
            // }
            if(this.selectDepositDates[0]&&this.selectDepositDates[1]){
                this.combineStatDetail.tableSearch.orderBeginDate = this.selectDepositDates[0];
                this.combineStatDetail.tableSearch.orderEndDate = this.selectDepositDates[1];
            }
            this.combineStatDetail.tableSearch.showZeroPriceOnly = this.combineStatDetail.showZeroPriceOnly;
            this.combineStatDetail.tableSearch.excelExport.enable = false;
            if (uuid) {
                this.combineStatDetail.tableSearch.uuid = uuid;
                this.combineStatDetail.uuid = uuid;
            }
            else{
                this.combineStatDetail.tableSearch.uuid = this.combineStatDetail.uuid;
            }

            this.combineStatDetail.show = true;
            this.combineStatDetail.loading = true;
            getDepositCombineSaleStatDetail(this.combineStatDetail.tableSearch).then(res => {
                this.combineStatDetail.loading = false;
                if (res.code === 0) {
                    this.combineStatDetail.preSaleData = res.data.listCombine;
                    let totalCount = 0;
                    let totalValue = 0;
                    let saleDiscountValueAll = 0;
                    let refundTotalValAll = 0;
                    let saleRealValueAll = 0;
                    let depositDuePaidAll=0;
                    let depositBillDetailsalesAssociateCommissionValue=0;
                    this.combineStatDetail.preSaleData.forEach(e => {
                        totalCount += e.preSaleDeliveryDetailQuantity;
                        totalValue += e.preSaleDeliveryDetailActProductCost;
                        depositDuePaidAll += e.depositDuePaid;
                        saleDiscountValueAll += e.saleDiscountValue;
                        refundTotalValAll += e.refundTotalVal;
                        saleRealValueAll += e.saleRealValue;
                        depositBillDetailsalesAssociateCommissionValue+=e.depositBillDetailsalesAssociateCommissionValue;
                    });
                    this.combineStatDetail.preSaleData.push({
                        preSaleDeliveryDetailQuantity: totalCount,
                        preSaleDeliveryDetailActProductCost: numberToFixed(totalValue, 2),
                        depositDuePaid:numberToFixed(depositDuePaidAll, 2),
                        saleDiscountValue: numberToFixed(saleDiscountValueAll, 2),
                        refundTotalVal: numberToFixed(refundTotalValAll, 2),
                        saleRealValue: numberToFixed(saleRealValueAll, 2),
                        depositBillDetailsalesAssociateCommissionValue:numberToFixed(depositBillDetailsalesAssociateCommissionValue, 2),
                        depositBillRecordCode: '合计'
                    });
                    search.globalSetFilterRecordCount(this.combineStatDetail.tableSearch, res.data.filterRecordCount);
                }
            });
        },
        getSaleStatList(reset = false) {
            this.reSetColumns();
            this.reSetsearchForm();
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }
            this.mainTable.tableSearch.totalOrderCost = this.totalOrderCost;
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.tableSearch.needExport = 0;
            this.mainTable.tableSearch.groupBy = this.groupBy;
            if(this.paidStatus){
                this.mainTable.tableSearch.paidStatus = this.paidStatus;
            }
            // if(this.selectDates[0]&&this.selectDates[1]){
            // 	this.mainTable.tableSearch.beginDate = this.selectDates[0];
            // 	this.mainTable.tableSearch.endDate = this.selectDates[1];
            // }
            if(this.selectDepositDates[0]&&this.selectDepositDates[1]){
                this.mainTable.tableSearch.orderBeginDate = this.selectDepositDates[0];
                this.mainTable.tableSearch.orderEndDate = this.selectDepositDates[1];
            }
            getDepositCombineSaleStat(this.mainTable.tableSearch).then(res => {
                this.mainTable.loading = false;
                if (res.code === 0) {
                    this.mainTable.data = res.data.listCombine;
                    let preSaleValueAll = 0;
                    let preSaleCountAll = 0;
                    let combinDepositAll = 0;
                    let saleDiscountValueAll = 0;
                    let refundTotalValAll = 0;
                    let saleRealValueAll = 0;
                    let commissionValueAll = 0;
                    this.mainTable.data.forEach(e => {
                        preSaleValueAll += e.preSaleValue;
                        preSaleCountAll += e.preSaleCount;
                        combinDepositAll += e.combinDeposit;
                        saleDiscountValueAll += e.saleDiscountValue;
                        refundTotalValAll += e.refundTotalVal;
                        saleRealValueAll += e.saleRealValue;
                        commissionValueAll +=e.commissionValue;
                    });
                    this.mainTable.data.push({
                        preSaleValue: numberToFixed(preSaleValueAll, 2),
                        preSaleCount: numberToFixed(preSaleCountAll, 2),
                        combinDeposit: numberToFixed(combinDepositAll, 2),
                        saleDiscountValue: numberToFixed(saleDiscountValueAll, 2),
                        refundTotalVal: numberToFixed(refundTotalValAll, 2),
                        saleRealValue: numberToFixed(saleRealValueAll, 2),
                        commissionValue: numberToFixed(commissionValueAll, 2),
                        groupName: '合计',
                        action: -1
                    });
                }
            }).catch(() => {
                this.mainTable.loading = false;
            });
        }
    }
};
</script>

<style scoped>
	.div-header{
		display: flex;
		justify-content: flex-end;
	}
	.div-header .btn-font{
		font-size: 18px;
		line-height: 0 !important;
	}
	.global-tool-bar .left-bar{
		height: 60px !important;
	}
	.global-tool-bar .right-bar{
		height: 60px !important;
	}
	.global-tool-bar .left-bar .title{
		width:110px !important;
		margin: 0 15px 0 5px !important;
	}
	.ivu-radio-group-button.ivu-radio-group-small .ivu-radio-wrapper{
		padding:0px 3px !important;
	}
</style>
